/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Reward } from '../../models/reward';

export interface UpdateLoyaltyProgramReward$Params {
  'Active-Tenant-Identifier': string;
  programId: string;
  rewardId: string;
      body: Reward
}

export function updateLoyaltyProgramReward(http: HttpClient, rootUrl: string, params: UpdateLoyaltyProgramReward$Params, context?: HttpContext): Observable<StrictHttpResponse<Reward>> {
  const rb = new RequestBuilder(rootUrl, updateLoyaltyProgramReward.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('programId', params.programId, {});
    rb.path('rewardId', params.rewardId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Reward>;
    })
  );
}

updateLoyaltyProgramReward.PATH = '/loyalty/programs/{programId}/rewards/{rewardId}';
